<template>
    <div id="app">
        <div v-if="routeName !== 'Login' && routeName !== 'Privacy'">
            <header-bar :wish-total="wishTotal"></header-bar>
            <div id="v-content" :style="{minHeight: Height+'px'}">
                <router-view />
            </div>
            <bottom-info></bottom-info>
        </div>
        <div v-else>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import HeaderBar from '@/components/headerBar/HeaderBar.vue';
import BottomInfo from '@/components/bottomInfo/BottomInfo.vue';
import { setTimeout } from 'timers';
import $ from 'jquery';

export default {
    components: {
        HeaderBar,
        BottomInfo,
    },
    data() {
        return {
            Height: 0,
            routeName: '',
            wishTotal: 0,
            aobiyaUserInfos: {},
            beforeUnloadTime: 0,
            gapTime: 0,
        };
    },
    watch: {
        '$route'(to, from) {
            this.routeName = to.name;
            this.$loading.close();
            // from 对象中要 router 来源信息.
            // do your want
        },
    },
    methods: {
        fetchWishData() {
            API.get('/api/aobiya/guest-fav-spu/count').then(res => {
                this.resetSetItem('wishTotal', res);
            });
        },
        async handleViewTime() {
            const viewAllTime = sessionStorage.getItem('startViewTime') ?
                parseInt(new Date().valueOf() / 1000, 10) - sessionStorage.getItem('startViewTime') : 0;
            await API.post('/api/aobiya/time/counter/guest', {
                guest_id: this.aobiyaUserInfos.id,
                seconds: viewAllTime,
            }).then(() => {
                localStorage.removeItem('viewFlag');
            });
        },
        beforeunloadHandler() {
            this.beforeUnloadTime = new Date().getTime(); // 获取刷新或者关闭前的动作
        },
        unloadHandler(e) {
            this.gapTime = new Date().getTime() - this.beforeUnloadTime;
            const viewAllTime = parseInt(new Date().valueOf() / 1000, 10) - sessionStorage.getItem('startViewTime');
            const goodsTime = parseInt(new Date().valueOf() / 1000, 10) - sessionStorage.getItem('goodsViewTime');
            //  判断是窗口关闭还是刷新
            if (this.gapTime <= 5) {
                //  如果是一步请求的话关闭了窗口也还没发出请求，所以需要使用同步的请求。
                //  记录浏览时长
                $.ajax({
                    headers: {
                        Authorization: `Bearer ${this.aobiyaUserInfos.token}`,
                    },
                    contentType: 'application/json', // 后台有设置接受类型，如果不加上可能报错，加了后还需要参数转成json格式
                    datatype: 'json',
                    url: '/api/aobiya/time/counter/guest',
                    data: JSON.stringify({
                        guest_id: this.aobiyaUserInfos.id,
                        seconds: viewAllTime,
                    }),
                    type: 'post',
                    async: false, // 或false,是否异步
                    success: function () {
                    },
                });
                if (sessionStorage.getItem('toPath') === 'productDetail') {
                    $.ajax({
                        headers: {
                            Authorization: `Bearer ${this.aobiyaUserInfos.token}`,
                        },
                        contentType: 'application/json', // 后台有设置接受类型，如果不加上可能报错，加了后还需要参数转成json格式
                        datatype: 'json',
                        url: '/api/aobiya/time/counter/spu',
                        data: JSON.stringify({
                            guest_id: this.aobiyaUserInfos.id,
                            seconds: goodsTime,
                            spu_id: sessionStorage.getItem('spu_id'),
                        }),
                        type: 'post',
                        async: false, // 或false,是否异步
                        success: function () {
                        },
                    });
                }
            }
        },
    },

    mounted() {
        if (localStorage.getItem('aobiyaUserInfos')) {
            this.aobiyaUserInfos = JSON.parse(localStorage.getItem('aobiyaUserInfos'));
            this.fetchWishData();
            window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
            window.addEventListener('unload', e => this.unloadHandler(e));
        }
        // 动态设置内容高度 让footer始终居底   header+footer的高度是515
        this.Height = document.documentElement.clientHeight - 515;
        // 监听浏览器窗口变化
        window.onresize = () => { this.Height = document.documentElement.clientHeight - 515; };
    },
    created() {
        window.addEventListener('setItem', () => {
            this.wishTotal = parseInt(sessionStorage.getItem('wishTotal'), 10) || 0;
        });
    },
    destroyed() {
        if (localStorage.getItem('aobiyaUserInfos')) {
            window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
            window.removeEventListener('unload', e => this.unloadHandler(e));
        }
    },
};
</script>

<style src="./assets/styles/app.scss" lang="scss"></style>

<style lang="scss">
</style>
